import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, Subject, combineLatest, delay, map, takeUntil, tap } from 'rxjs';
import { Utility } from 'src/app/core/common';
import { bucketItem } from 'src/app/services/resource.service';
import { IrtwadModel, RtwadSearchResult, RtwadSearchCriteria, RtwadService } from 'src/app/services/rtwad.service';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { Constants } from 'src/app/states/constants';

@Component({
	selector: 'app-rtwad-admin-list',
	templateUrl: './rtwad-admin-list.component.html',
	styleUrls: ['./rtwad-admin-list.component.scss']
})
export class RtwadAdminListComponent implements OnInit, OnDestroy {

	private DEFAULT_FROM = 0
	private DEFAULT_LIMIT = 20

	criteria: RtwadSearchCriteria;
	from = this.DEFAULT_FROM;
	limit = this.DEFAULT_LIMIT;

	verifyCriteria = new RtwadSearchCriteria({
		Source: 'karpishe',
		Statuses: ['Pending']
	});

	searchResult: RtwadSearchResult;
	item: IrtwadModel;

	private oldSearch: any = { dummy: "yes" };

	statusTranslation = Constants.Translations.RtwadStatus;
	sources$: Observable<bucketItem[]>;

	constructor(public rtwadService: RtwadService, private route: ActivatedRoute, private router: Router, private spinner: SpinnerService) {
		
	}
	
	ngOnInit(): void {
		combineLatest([this.route.params, this.route.queryParams]).pipe(
			map(_ => { return { ..._[0], ..._[1] } }),
			takeUntil(this.unsubscribe$),
		).subscribe(async (params) => await this.load(params));
		this.sources$ = this.rtwadService.getSources$();
	}


	private unsubscribe$ = new Subject<void>();
	ngOnDestroy() {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	async load(params: Params) {
		const newCriteria = new RtwadSearchCriteria(JSON.parse(params?.criteria || '{"Sort" : "RegisterTime"}'));

		const newSearch = { ...newCriteria, from: +params?.from || this.DEFAULT_FROM, limit: +params?.limit || this.DEFAULT_LIMIT };


		//console.log('Old search:'+JSON.stringify(this.oldSearch));
		//console.log('New search:'+JSON.stringify(newSearch));

		if (Utility.isDifferent(this.oldSearch, newSearch)) {
			this.criteria = newCriteria;
			this.from = +params?.from || this.DEFAULT_FROM;
			this.limit = +params?.limit || this.DEFAULT_LIMIT;

			this.spinner.show('rtwad-list')
			console.log('search$ started');
			this.searchResult = await this.rtwadService.adminSearch(this.criteria, this.from, this.limit)
			this.spinner.hide('rtwad-list');

			this.oldSearch = { ...JSON.parse(JSON.stringify(this.criteria)), from: this.from, limit: this.limit };
		}

		if (params?.id && params?.id != this.item?.Id)
			this.item = await this.rtwadService.adminGetById(params.id);
		else if (!params?.id)
			delete this.item;

	}

	navigateToSearch(pageEvent: any = null) {


		let from = pageEvent ? pageEvent.from : this.from;
		let limit = pageEvent ? pageEvent.limit : this.limit;

		this.router.navigate([], { queryParams: { id: this.item?.Id, from: from, limit: limit, criteria: JSON.stringify(this.criteria) } })
	}


}
